import { useEffect, useMemo } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';

import NavItemWrapper from '~/common/components/Nav/components/NavItemWrapper';
import SelectedCategoryNavContainer from '~/common/components/Nav/components/SelectedCategoryNavContainer';
import { useNavFeatureFlags } from '~/common/hooks/useNavFeatureFlags';

import PageLayout from '../GlobalLayout/PageLayout/PageLayout';
import { NavWrapper } from '../Nav/components/Styled';
import { useKnowYourLoanSummaryQuery } from './hooks';
import './styles.css';

export default function KnowYourLoan() {
  const navigate = useNavigate();
  const { category } = useParams();

  useEffect(() => {
    if (category) {
      return;
    }

    navigate('primary');
    // eslint-disable-next-line @eslint-react/exhaustive-deps
  }, [category]);

  return (
    <PageLayout
      leftDrawerContent={null}
      topNav={<Navigation />}
      miscUtilityContainers={null}
    >
      <Outlet />
    </PageLayout>
  );
}

const Navigation = () => {
  const { data } = useKnowYourLoanSummaryQuery();

  const includeKnowYourLoanFlag = useNavFeatureFlags().IncludeKnowYourLoan;

  const navItems = useMemo(() => {
    if (!includeKnowYourLoanFlag) {
      return [];
    }

    return data?.screenData?.borrowers?.map((borrower) => {
      const borrowerName = `${borrower.firstName} ${borrower.lastName}`;

      return (
        <NavItemWrapper
          key={borrowerName}
          label={borrowerName}
          to={
            borrower.isPrimaryBorrower
              ? 'primary'
              : borrower.customerRecordId.toString()
          }
        />
      );
    });
  }, [data?.screenData?.borrowers, includeKnowYourLoanFlag]);

  return (
    <NavWrapper>
      <SelectedCategoryNavContainer>{navItems}</SelectedCategoryNavContainer>
    </NavWrapper>
  );
};
